module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-page-wrapper"
  }, [_c('split-layout', {
    attrs: {
      "cols": _vm.showTextInfo ? 3 : 2,
      "sidebar_left_width": 'width:20% ',
      "sidebar_right_width": 'width:600px;'
    },
    on: {
      "clickCollapse": _vm.clickCollapse,
      "dragStop": _vm.dragStop
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTextInfo),
      expression: "showTextInfo"
    }],
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-1"
    },
    slot: "sidebar-1"
  }, [_c('SidebarView', {
    attrs: {
      "list": _vm.sidebarLeftList,
      "hiddenToolbar": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__modus-main",
    attrs: {
      "slot": "main-content"
    },
    slot: "main-content"
  }, [(_vm.geoData) ? [_c('MapView', {
    attrs: {
      "geoData": _vm.geoData,
      "option": _vm.mapOption
    },
    on: {
      "inited": _vm.mapInited
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "slot": "sidebar-2"
    },
    slot: "sidebar-2"
  }, [_c('SidebarView', {
    attrs: {
      "list": _vm.sidebarRightList
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70a820be","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OrteUndWege.vue
// module id = 1979
// module chunks = 1